import React, { useState, useEffect } from 'react';
import styled, { keyframes, css } from 'styled-components';

const actionPrompts = [
  "Motivation ain't enough G, you gotta put in the work too!",
  "Enough time feeding in the motivation, time to use that.",
  "Reading quotes is easy. Taking action is what counts.",
  "Don't just collect wisdom. Apply it.",
  "The Stoics didn't just think. They acted. Your turn.",
  "Wisdom without action is like a car without fuel.",
  "Close this app and go do something meaningful.",
  "The best time to start was yesterday. The second best is now."
];

const ActionPrompt = () => {
  const [prompt, setPrompt] = useState('');
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show the prompt after 30 seconds
    const timer = setTimeout(() => {
      const randomPrompt = actionPrompts[Math.floor(Math.random() * actionPrompts.length)];
      setPrompt(randomPrompt);
      setVisible(true);
    }, 30000);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <PromptContainer>
      <PromptContent>
        <PromptText>{prompt}</PromptText>
        <CloseButton onClick={handleClose}>&times;</CloseButton>
      </PromptContent>
    </PromptContainer>
  );
};

const slideUp = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const PromptContainer = styled.div`
  position: fixed;
  bottom: 20px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  z-index: 100;
  animation: ${css`${slideUp} 0.5s ease-out forwards`};
`;

const PromptContent = styled.div`
  background: linear-gradient(145deg, #1a1a1a, #0a0a0a);
  border: 1px solid #d4af37;
  border-radius: 8px;
  padding: 1rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
  max-width: 90%;
  width: 600px;
`;

const PromptText = styled.p`
  color: #d4af37;
  font-family: var(--font-primary);
  font-size: 1.1rem;
  margin-right: 1rem;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: var(--color-secondary);
  font-size: 1.5rem;
  cursor: pointer;
  transition: color 0.3s ease;

  &:hover {
    color: #d4af37;
  }
`;

export default ActionPrompt;
